module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Fire and Granite")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("By Andrew Grey")]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("A Carlisle Deputies Novel")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("The heat is growing from the inside, but danger is building on the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Judge Andrew Phillips runs a tight ship in his courtroom. He’s tough, and when he hands down a sentence, he expects to be obeyed. So when a fugitive named Harper escapes and threatens his life, Andrew isn’t keen on 24/7 protection… especially not from Deputy Clay Brown. They have a past, one that could cause problems in their careers.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("But with Clay assigned to Andrew and the two of them together every minute, there’s nowhere to hide from their attraction—or from the fact that there’s much more than chemistry blooming between them. As the threat intensifies, Clay knows he’ll do anything it takes to protect the people who are taking their places in his heart: Andrew and his young niece and nephew.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8deb9c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section-0002.vue
// module id = 60
// module chunks = 0